import { RootState, OnboardingState } from '../types';
import { Action } from 'vuex';
// initial state
const state = {};

// actions
const actions: { [key: string]: Action<OnboardingState, RootState> } = {
  show({ dispatch, rootState, rootGetters }) {
    dispatch(
      'modal/show',
      {
        type: 'Onboarding',
        payload: {
          canHaveTrial: rootState.user.canHaveTrial,
          leaseState: rootState.user.leaseState,
          isInTrial: rootGetters['user/remainingTrialDays'] !== false,
        },
      },
      { root: true }
    );
  },

  hide({ dispatch }) {
    dispatch(
      'modal/hide',
      {
        type: 'Onboarding',
      },
      { root: true }
    );
  },
};

export default {
  namespaced: true,
  state,
  actions,
};
